import React, { useState } from "react";
import IconFaChevRight from "../img/IconFaChevRight";

function ResumeSidebar() {
  const [skills] = useState([
    {
      id: "prototyping",
      title: "Prototyping",
      list: [
        "Component build using React & Angular",
        "Interactive wireframing with Sketch & InvisionApp",
        "Responsive & mobile-first prototypes",
      ],
    },
    {
      id: "discovery",
      title: "Product discovery",
      list: [
        "Qualitative & quantitative user testing",
        "Experimentation - A/B testing for e-commerce",
      ],
    },
    {
      id: "creative",
      title: "Creative",
      list: [
        "Ideation",
        "Typography & design principles",
        "Illustration / iconography design",
      ],
    },
    {
      id: "team",
      title: "Team",
      list: [
        "Design mentoring & critique",
        "Excellent verbal & written communication",
        "Strong collaboration with multi-disciplinary teams",
      ],
    },
    {
      id: "business",
      title: "Business",
      list: [
        "Lean UX / Agile",
        "Delivering to Key Performance Indicators",
        "Working to Objectives & Key Results",
      ],
    },
    {
      id: "tools",
      title: "Tools",
      list: [
        "HTML / CSS (SCSS) / JavaScript (ES6)",
        "VS Code",
        "Bitbucket / Git",
        "Sketch App",
        "Invision App",
        "Adobe CC",
        "Browserstack",
        "Hotjar / Mouseflow / Usertesting.com",
      ],
    },
  ]);

  return (
    <>
      {skills.map((skill) => (
        <div className="cv-card">
          <h4 className="cv-subtitle">{skill.title}</h4>
          <ul className="cv-list">
            {skill.list.map((items) => (
              <li className="item">
                <IconFaChevRight />
                {items}
              </li>
            ))}
          </ul>
        </div>
      ))}
      <div className="cv-card">
        <h3 class="cv-title">education</h3>
        <h4 class="cv-sectiontitle">
          Diploma in Design &amp; Visual Communication
        </h4>
        <ul className="cv-list">
          <li className="item">
            <IconFaChevRight /> 3 year full time course
          </li>
          <li className="item">
            <IconFaChevRight />
            AIT.ie (Athlone Institute of Technology, Ireland)
          </li>
          <li className="item">
            <IconFaChevRight /> Graduated 1997
          </li>
        </ul>
      </div>
    </>
  );
}

export default ResumeSidebar;
